import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AppsTable from "../../components/AppsTable";
import DialogBox from "../../components/DialogBox";
import FloatingButton from "../../components/FloatingButton";
import LoadingSpinner from "../../components/LoadingSpinner";
import { instance as axios } from "../../utils/axiosConfig";

export default function MyApps() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [creatingApp, setCreatingApp] = useState(false);
  const [details, setDetails] = useState({
    name: "",
    type: "PAYBILL",
    paybill: "",
    bank: "",
    account: "",
    till: "",
  });

  const [banks, setBanks] = useState([]);
  const [apps, setApps] = useState([]);

  //fetch banklist
  const getBanks = async () => {
    const resp = await axios.get("/banks");
    setBanks(resp.data.banks);
  };

  //fetch user apps
  const getApps = async () => {
    setFetching(true);
    const resp = await axios.get("/get-user-apps");
    setApps(resp.data.apps);
    setFetching(false);
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCreatingApp(true);
    try {
      const resp = await axios.post("/app/create", {
        name: details.name,
        type: details.type,
        account_no: details.account,
        bank: details.bank,
        merchant: details.paybill || details.till,
      });
      console.log(resp.data.message);
      toast.success(resp.data.message);
      setCreatingApp(false);
      handleDialogClose();
      getApps();
    } catch (error) {
      // console.log(error.response);
      toast.error(error.response.data);
      setCreatingApp(false);
    }
  };

  const handleDialogClose = () => {
    setDetails({
      name: "",
      type: "PAYBILL",
      paybill: "",
      bank: "",
      account: "",
      till: "",
    });
    setIsDialogOpen(false);
  };

  useEffect(() => {
    getBanks();
    getApps();
  }, []);

  return (
    <div>
      {fetching ? (
        <LoadingSpinner />
      ) : (
        <>
          <AppsTable apps={apps} />
          {!isDialogOpen && (
            <FloatingButton
              title="Register New App"
              func={() => setIsDialogOpen(true)}
            />
          )}

          <DialogBox
            isOpen={isDialogOpen}
            setIsOpen={setIsDialogOpen}
            title="Register New App"
            onClose={handleDialogClose}
          >
            {creatingApp ? (
              <LoadingSpinner />
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    App Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={details.name}
                    onChange={handleChange}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                    placeholder="app name"
                    //   value=""
                    required
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Select App Type
                  </label>

                  <fieldset className="flex justify-around">
                    <legend className="sr-only">Type</legend>
                    <div className="flex items-center mb-4">
                      <input
                        id="paybill"
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        defaultValue="PAYBILL"
                        className="w-4 h-4 border-gray-300 focus:outline-none"
                        defaultChecked
                      />
                      <label
                        htmlFor="paybill"
                        className="block ml-2 text-sm font-medium text-gray-400"
                      >
                        Paybill
                      </label>
                    </div>
                    <div className="flex items-center mb-4">
                      <input
                        id="till"
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        defaultValue="TILL"
                        className="w-4 h-4 border-gray-300 focus:outline-none"
                      />
                      <label
                        htmlFor="till"
                        className="block ml-2 text-sm font-medium text-gray-400"
                      >
                        Till (buy goods)
                      </label>
                    </div>
                    <div className="flex items-center mb-4">
                      <input
                        id="bank"
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        defaultValue="BANK"
                        className="w-4 h-4 border-gray-300 focus:outline-none"
                      />
                      <label
                        htmlFor="bank"
                        className="block ml-2 text-sm font-medium text-gray-400"
                      >
                        Bank
                      </label>
                    </div>
                  </fieldset>
                </div>
                {details.type === "PAYBILL" && (
                  <div className="mb-6">
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Paybill Number
                    </label>
                    <input
                      type="number"
                      id="name"
                      name="paybill"
                      value={details.paybill}
                      onChange={handleChange}
                      className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                      placeholder="enter paybill number"
                      //   value=""
                      required
                    />
                  </div>
                )}
                {details.type === "TILL" && (
                  <div className="mb-6">
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Till Number (Buy Goods)
                    </label>
                    <input
                      type="number"
                      id="name"
                      name="till"
                      value={details.till}
                      onChange={handleChange}
                      className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                      placeholder="enter till number"
                      //   value=""
                      required
                    />
                  </div>
                )}

                {details.type === "BANK" && (
                  <>
                    <div className="mb-6">
                      <div>
                        <label
                          htmlFor="banks"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Select Bank
                        </label>
                        <select
                          id="banks"
                          name="bank"
                          onChange={handleChange}
                          value={details.bank}
                          className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                        >
                          <option value="">Select Bank</option>
                          {banks.length >= 1 &&
                            banks.map((bank) => (
                              <option key={bank._id} value={bank.name}>
                                {bank.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="mb-6">
                      <label
                        htmlFor="name"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Account Number
                      </label>
                      <input
                        type="number"
                        id="name"
                        name="account"
                        value={details.account}
                        onChange={handleChange}
                        className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
                        placeholder="enter account number"
                        //   value=""
                        required
                      />
                    </div>
                  </>
                )}

                <button
                  type="submit"
                  className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                >
                  Send Request
                </button>
              </form>
            )}
          </DialogBox>
        </>
      )}
    </div>
  );
}
